import React from 'react';
import { Row, Modal } from 'react-bootstrap';
import Button from "@material-ui/core/Button";
import { SESSION_STORAGE_AMERICO_KEY, setSessionStorageItem, getSessionStorageItem, SESSION_STORAGE_CUSTOMIZED_TERM_KEY, SESSION_STORAGE_COVR_FULLUW_KEY } from '../../../../sessionStorage';

export default function ExceedCovgAmountModal(props) {

    const handleCovgAmount = () => {
        const customFullFormState = getSessionStorageItem(SESSION_STORAGE_CUSTOMIZED_TERM_KEY);
        const mctFullFormState = getSessionStorageItem(SESSION_STORAGE_COVR_FULLUW_KEY);
        let path = '';
        let fullForm = { ...props.fullFormState };

        if (customFullFormState && customFullFormState.pages.preQuote.coverageAmountQuote === fullForm.steps.quoter.coverageAmount) {
            let customizeFullForm = { ...customFullFormState };
            customizeFullForm.pages.quoter.coverageAmount = customizeFullForm.pages.preQuote.coverageAmountQuote = 1000000;
            setSessionStorageItem(SESSION_STORAGE_CUSTOMIZED_TERM_KEY, customizeFullForm);
            path = '/term-insurance/quote-results';
        }
        else if (mctFullFormState && mctFullFormState.pages.preQuote.coverageAmountQuote === fullForm.steps.quoter.coverageAmount) {
            let mctFullForm = { ...mctFullFormState };
            mctFullForm.pages.quoter.coverageAmount = mctFullForm.pages.preQuote.coverageAmountQuote = 1000000;
            setSessionStorageItem(SESSION_STORAGE_COVR_FULLUW_KEY, mctFullForm);
            path = '/quote/term-life-insurance/multi-carrier-term/get-a-quote';
        }
        else {
            path = '/quote/term-life-insurance/loan-protector/get-a-quote';
        }
        fullForm.steps.quoter.coverageAmount = 1000000;
        props.onMultiFieldChange(fullForm);
        setSessionStorageItem(SESSION_STORAGE_AMERICO_KEY, fullForm);
        props.onHide();
        props.history.push(path);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
            <Modal.Header className='pb-0' closeButton>
                <Modal.Title className='px-3'>Coverage Mismatch</Modal.Title>
            </Modal.Header>
            <Modal.Body className="model-body d-flex text-left p-3 flex-column">
                <p className='model-content'>It appears that your selected coverage amount exceeds the maximum amount allowed for the Americo Loan Protector product. Please return to the quote results and select an option which fits your needs.</p>
                <Row>
                    <div className='py-2'>
                        <Button variant='contained' size="medium" color="primary" onClick={() => handleCovgAmount()}>FIX COVERAGE AMOUNT</Button>
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/Helpers/ExceedCovgAmountModal.js